angular.module('unica_campaign_template.campaign_template_controllers')

.controller('CampaignTemplateListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	CampaignTemplateListService, CampaignTemplateDeleteService, CampaignTemplateCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.campaignTemplateList = [];

	$scope.showLoader();

	loadCampaignTemplateList();
	
	function loadCampaignTemplateList() {
		CampaignTemplateListService
		.list($scope.event_id)
		.then(function(data) {
			$scope.hideLoader();

			if ( data ) {
				$scope.campaignTemplateList = data;
			}
		});
	}

	$scope.deleteCampaignTemplate = function(campaignTemplateId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il template?',
			text: 'Confermi la cancellazione del template?'
		}).then(function() {

			$scope.showLoader();

			CampaignTemplateDeleteService
				.delete( campaignTemplateId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.campaignTemplateList, function(campaign, key) {
							if ( campaign.id === campaignTemplateId ) {
								$scope.campaignTemplateList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Template Campagna eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.cloneCampaignTemplate = function(campaignTemplateId)
	{
		
			CampaignTemplateCreateService
				.clone( campaignTemplateId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$scope.showSuccessMsg('Template Campagna duplicato con successo!', '');
						loadCampaignTemplateList();

					}

				});

	};

})

;